module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "prop": _vm.item.key
    }
  }, [_c('template', {
    slot: "label"
  }, [(_vm.item.popover && _vm.item.popover_text) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.item.label) + "\n      "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.item.popover_text) + "\n        "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-info pointer"
  })])])], 1) : _c('span', [_vm._v(_vm._s(_vm.item.label))])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f72acb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/DyFormitemWraper.vue
// module id = 710
// module chunks = 20